
import { NgModule } from '@angular/core';
import { AttachmentInputComponent } from './components/attachment-input/attachment-input.component';

import { NzUploadModule } from 'ng-zorro-antd/upload'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AttachmentViewerComponent } from './components/attachment-viewer/attachment-viewer.component'
import { NzIconModule } from 'ng-zorro-antd/icon'
@NgModule({
    imports: [NzUploadModule, CommonModule, TranslateModule, NzIconModule],
    exports: [NzUploadModule, AttachmentInputComponent, AttachmentViewerComponent],
    declarations: [AttachmentInputComponent, AttachmentViewerComponent],
    providers: [],
})
export class MmAttachmentModule {

}
